export default __webpack_public_path__ + "static/media/menu.e8af0f5b.svg";